export default __webpack_public_path__ + "e2a257e6f61a50eeb615daabb38514b6.png";